<template>
  <div class="Footer flex-row items-center font12">
    <!-- <p @click="downFile" class="down-div-phone" style="">
        <img
          style="width: 20px; margin-right: 10px;"
          src="@/assets/download.png"
          alt=""
        />
        DOWNLOAD E-BROCHURE
      </p> -->
    <div class="Footer-left flex-row">
      <!-- <img class="Footer-left-img1" src="@/assets/logo2.png" alt=""> -->
       
      <div
        class="Footer-left-div flex-row items-center content-end items-start"
        style="flex-direction: column-reverse;"
      >
        <div class="left-div-logo c-logo">
          <img src="@/assets/btn/btm-logo.png" alt="" />
          <img src="@/assets/btn/btm-logo1.png" alt="" />
        </div>
        <p class="c-logo-title">THE ESTEEMED COLLECTION BY</p>
      </div>
      <div class="Footer-left-div flex-row  items-center items-end">
        <div class="left-div-logo l-logo">
          <img
            @click="OpenUrl('https://www.facebook.com/hoihuprealtydeveloper')"
            src="@/assets/btn/fb.png"
            alt=""
          />
          <!-- <img
            @click="OpenUrl('https://www.instagram.com/novoplace_ec/')"
            src="@/assets/btn/is.png"
            alt=""
          /> -->
        </div>
        <p>DISCOVER MORE HERE</p>
      </div>
    </div>
    <div class="Footer-right flex-column items-end">
      <!-- <p @click="downFile" class="down-div" style="">
        <img
          style="width: 20px; margin-right: 10px;"
          src="@/assets/download.png"
          alt=""
        />
        DOWNLOAD E-BROCHURE
      </p> -->
      <p class="medium f20">
        FOR ENQUIRIES: 6311 9555 | ENQUIRY@HOIHUP.COM
      </p>
        <br />
        <p>
        © COPYRIGHT {{currentYear}} HOI HUP SUNWAY <span style="margin: 0 10px">|</span>
        <!-- <span class="underline" @click="DocType(1)">LEGALITIES</span> -->
        <!-- <span style="margin: 0 10px">|</span> -->
        <span class="underline" @click="DocType(2)">DISCLAIMER</span>
        <!-- <span style="margin: 0 10px">|</span> -->
        <!-- <span class="underline" @click="DocType(3)">PRIVACY POLICY</span> -->
      </p>
    </div>
    <div class="Pop-win" v-show="docPopType" >
      <div class="Pop-Bg" @click="docPopType = !docPopType"></div>
      <div class="Pop-Disc-Data">
        <!-- <div style="color: #a98b59;" class="Pop-x" @click="docPopType = !docPopType">X</div> -->
        <img class="Pop-x" @click="docPopType = !docPopType" src="@/assets/btn/close.png" alt="">
        <div class="pop-logo">
          <img style="height: 100%;object-fit: contain;    margin-right: 20px;" src="@/assets/logo3.png" alt="">
        </div>
        <div v-if="docIndex == 1" class="disc-content">
        

        </div>
        <div v-if="docIndex == 2" class="disc-content">
          <p class="doc-title">LEGALITIES</p>
        <p>
          Developer: Hoi Hup Sunway Plantation Pte Ltd • Company Reg No.: 202406316D • Developer’s Licence No.: C1522 • Tenure of Land: 99 years from 13 May 2024 
          • Lot No.: Lot 05428V MK 10 at Plantation Close (Tengah planning area) • Notice of Vacant Possession: 30 June 2030 • Notice of Completion: 30 June 2033 • BP 
          Approval No.: A1839-00007-2024-BP01 dated 08 May 2025 • Encumbrances on the Land: Mortgage in favour of Oversea-Chinese Banking Corporation Limited
        </p>
        <p>
          All reasonable care has been taken in preparing this page and in constructing the models and sales gallery/showflats and all statements are believed to be correct but are not to be regarded as statements or representations of fact. All information and specifications are current at the time of going to press and are subject to such changes as may be required by the Developer. All plans and models are not to scale unless expressly stated and are subject to any amendments which are required or approved by the relevant authorities. Renderings and illustrations are artist’s impressions only and photographs are only decor suggestions and cannot be regarded as representations of fact. All areas and other measurements are subject to final survey. The Option to Purchase embodies all the terms and conditions between the Developer and the Purchaser and supersedes and cancels in all respects all previous representations, warranties, promises, inducements or statements of intention, whether written or oral made by the Developer and/or the Developer’s agent which are not embodied in the Option to Purchase.
        </p>
        <br />
        <!-- <div style="width: 100%;background-color: #575252; height: 1px;margin: 10px auto;"></div> -->
        <!-- <br /> -->
          <p class="doc-title">TERMS & CONDITIONS</p>
        <p>
          Please read all these terms and conditions contained in this page carefully. By accessing this site and any of the pages thereof, you are agreeing to be bound by the terms and conditions below. If you are not agreeable to the terms and conditions set out below, do not access the site, or any of the pages thereof.
        </p>
          <br />
        
        <p class="doc-title-1">USE OF INFORMATION AND MATERIALS</p>
        <p>
          The information and materials contained in these pages – and the terms, conditions, and descriptions that appear – are subject to change at discretion of Hoi Hup Sunway Plantation Pte Ltd  ("HHSP").
        </p>
          <br />

        <p class="doc-title-1">LIABILITY DISCLAIMERS</p>
        <p>
          The information and materials contained in this site, including text, graphics, links or other items – are provided “as is”, “as available”. HHSP does not warrant the accuracy, adequacy or completeness of this information and materials and expressly disclaims liability for errors or omissions in this information and materials.
          <br />
          <br />
          No warranty of any kind, implied, expressed or statutory, including but not limited to the warranties of non-infringement of the third-party rights, title, merchantability, fitness for a particular purpose and freedom from computer virus, is given in conjunction with the information and materials.
          <br />
          <br />
          This website may include publications with technical inaccuracies or typographical errors that will be corrected as they are discovered at HHSP's sole discretion. Also, changes are periodically added to the information contained herein. These corrections and changes may be incorporated into the HHSP website at a later date. HHSP may at any time make modifications, improvements and/or changes to these Terms and Conditions, the information, names, images, pictures, logo, and icons displayed on the HHSP website or products and services referred to within, with or without notice.
          <br />
          <br />
          HHSP website may contain links or references to other websites that may be accessed. These websites may orignate outside the boundaries of the HHSP website and which information HHSP will have no control. Therefore, HHSP shall have no obligation or responsibility regarding any content derived, obtained, accessed within, through or outside HHSP website.
          <br />
          <br />
          In no event shall HHSP, or any of its subsidiaries, affiliates, marketing & partners be liable for any damages, including without limitation, direct or indirect, special, incidental, or consequential damages, whatsoever resulting from access or use, or inability to access or use the HHSP website or arising out of any materials, information, qualifications or recommendations on this website.
        </p>
        <br />

        <p class="doc-title-1">COPYRIGHT © HOI HUP SUNWAY PLANTATION PTE LTD. ALL RIGHTS RESERVED.</p>
        <p>
          Copyright in the contents of the HHSP website, in the information therein and in their arrangement, is owned by HHSP unless otherwise indicated.
          <br />
          <br />
          No hyperlinking of this website to any other website or the mirroring or reproduction of any information on this website on any other website or the use of any information therein for any public or commercial purpose is permitted without the prior written consent of HHSP, which consent may be granted or refused at its sole discretion and may be subject to terms and conditions imposed by HHSP.
        </p>
        
        <br />
        <!-- <div style="width: 100%;background-color: #575252; height: 1px;margin: 10px auto;"></div> -->
        <br />

        <!-- </div>
        <div v-if="docIndex == 3" class="disc-content"> -->

        <p class="doc-title">PRIVACY & POLICY</p>
        <p>
          We at Hoi Hup Sunway Plantation Pte Ltd (“HHSP”) take our responsibilities under Singapore’s Personal Data Protection Act 2012 (the “PDPA”) seriously. We also recognise the importance of the personal data you have entrusted to us and believe that it is our responsibility to properly manage, protect and process your personal data. This Data Protection Policy is designed to assist you in understanding how we collect, use, disclose and/or process the personal data you have provided to us, as well as to assist you in making an informed decision before providing us with any of your personal data. If you, at any time, have any queries on this policy or any other queries in relation to how we may manage, protect and/or process your personal data, please do not hesitate to contact our Data Protection Officer (the “DPO”) at: 
          <a href="mailto:dpo@hoihup.com">dpo@hoihup.com</a></p>
          <br />
          <ol>
            <li >
              <p class="doc-title-1">INTRODUCTION TO THE PDPA</p>
              <ol>
                <li><p>
                  “Personal Data” is defined under the PDPA to mean data, whether true or not, about an individual who can be identified from that data, or from that data and other information to which an organisation has or is likely to have access. Common examples of personal data could include names, identification numbers, contact information, medical records, photographs and video images.
                </p></li>
                <li><p>
                  We will collect your personal data in accordance with the PDPA. We will notify you of the purposes for which your personal data may be collected, used, disclosed and/or processed, as well as obtain your consent for the collection, use, disclosure and/or processing of your personal data for the intended purposes, unless an exception under the law permits us to collect and process your personal data without your consent.
                </p></li>
              </ol>
            </li>
            <br />

            <li>
              <p class="doc-title-1">PURPOSES FOR COLLECTION, USE, DISCLOSURE AND PROCESSING OF PERSONAL DATA</p>
              <ol>
                <li>
                  <p>The personal data which we collect from you may be used, disclosed and/or processed for various purposes, depending on the circumstances for which we may/will need to process your personal data, including:</p>
                  
                  <ol>
                    <li><p>contacting you for marketing purposes.</p></li>
                    <li><p>processing your application.</p></li>
                    <li><p>sales matters.</p></li>
                    <li><p>estate matters.</p></li>
                    <li><p>key collection arrangement.</p></li>
                    <li><p>defects rectification.</p></li>
                    <li><p>processing of payment including invoicing.</p></li>
                    <li><p>any other purposes which we will notify you of at the time of obtaining your consent. (collectively, the “Purposes”).</p></li>
                    <p style="margin-left: 0;">
                      As the purposes for which we may/will collect, use, disclose or process your personal data depend on the circumstances at hand, such purpose may not appear above. However, we will notify you of such other purpose at the time of obtaining your consent, unless processing of your personal data without your consent is permitted by the PDPA or by law.
                    </p>
                  </ol>
                </li>
                <li><p>
                  In order to conduct our business operations more smoothly, we may also be disclosing the personal data you have provided to us to our third-party service providers, agents and/or our affiliates or related corporations, and/or other third-parties whether sited in Singapore or outside of Singapore, for one or more of the above-stated Purposes. Such third-party service providers, agents and/or affiliates or related corporations and/or other third-parties would be processing your personal data either on our behalf or otherwise, for one or more of the above-stated Purposes.
                </p></li>
              </ol>
            </li>

          <br />

            <li>
              <p class="doc-title-1">SPECIFIC ISSUES FOR THE DISCLOSURE OF PERSONAL DATA TO THIRD-PARTIES</p>
              
              <ol>
                <li><p>We respect the confidentiality of the personal data you have provided to us.</p></li>
                <li>
                  <p>
                    In that regard, we will not disclose your personal data to third-parties without first obtaining your consent permitting us to do so. However, please note that we may disclose your personal data to third-parties without first obtaining your consent in certain situations, including, without limitation, the following:
                  </p>
                  <ol>
                    <li><p>cases in which the disclosure is required or authorised based on the applicable laws and/or regulations;</p></li>
                    <li><p>cases in which the purpose of such disclosure is clearly in your interests, and if consent cannot be obtained in a timely way;</p></li>
                    <li><p>cases in which the disclosure is necessary to respond to an emergency that threatens the life, health or safety of yourself or another individual;</p></li>
                    <li><p>cases in which the disclosure is necessary for any investigation or proceedings;</p></li>
                    <li><p>cases in which the personal data is disclosed to any officer of a prescribed law enforcement agency, upon production of written authorisation 
                  signed by the head or director of that law enforcement agency or a person of a similar rank, certifying that the personal data is necessary for the 
                  purposes of the functions or duties of the officer;</p></li>
                    <li><p>cases in which the disclosure is to a public agency and such disclosure is necessary in the public interest; and/or</p></li>
                    <li><p>where such disclosure without your consent is permitted by the PDPA or by law.</p></li>
                  </ol>
                </li>
                <li><p>
                  The instances listed above at paragraph 3.2 are not intended to be exhaustive. For more information on the exceptions, you are encouraged to peruse the 
                  Second, Third and Fourth Schedules of the PDPA which is publicly available at <a href="https://sso.agc.gov.sg/" target="_blank" rel="noopener noreferrer">https://sso.agc.gov.sg/</a>.
                </p></li>
                <li><p>
                  Where we disclose your personal data to third-parties with your consent, we will employ our best efforts to require such third-parties to protect your personal data.
                </p></li>
              </ol>
            </li>
          <br />

            <li>
              <p class="doc-title-1">REQUEST FOR ACCESS AND/OR CORRECTION OF PERSONAL DATA</p>
              
              <ol>
                <li><p>
                  You may request to access and/or correct the personal data currently in our possession or control by submitting a written request to us. We will need enough information from you in order to ascertain your identity as well as the nature of your request, so as to be able to deal with your request. Hence, please submit your written request at the following email address: 
                   <a href="mailto:dpo@hoihup.com">dpo@hoihup.com</a>.
                </p></li>
                <li><p>
                  For a request to access personal data, once we have sufficient information from you to deal with the request, we will seek to provide you with the relevant personal data within 30 days. Where we are unable to respond to you within the said 30 days, we will notify you of the soonest possible time within which we can provide you with the information requested. Note that the PDPA exempts certain types of personal data from being subject to your access request.
                </p></li>
                <li>
                  <p>For a request to correct personal data, once we have sufficient information from you to deal with the request, we will:</p>
                  <ol>
                    <li><p>
                      correct your personal data within 30 days. Where we are unable to do so within the said 30 days, we will notify you of the soonest practicable time within which we can make the correction. Note that the PDPA exempts certain types of personal data from being subject to your correction request as well as provides for situation(s) when correction need not be made by us despite your request; and
                      </p></li>
                      <li><p>
                        subject to paragraph [4.4], we will send the corrected personal data to every other organisation to which the personal data was disclosed by HHSP within a year before the date the correction was made, unless that other organisation does not need the corrected personal data for any legal or business purpose.
                      </p></li>
                  </ol>
                </li>
                <li><p>
                  Notwithstanding paragraph [4.3(b)], we may, if you so consent, send the corrected personal data only to specific organisations to which the personal data was disclosed by us within a year before the date the correction was made.
                </p></li>
                <li><p>
                  We will also be charging you a reasonable fee for the handling and processing of your requests to access your personal data. We will provide you with a written estimate of the fee we will be charging. Please note that we are not required to respond to or deal with your access request unless you have agreed to pay the fee.
                </p></li>
              </ol>
            </li>
          <br />

            <li>
              <p class="doc-title-1">REQUEST TO WITHDRAW CONSENT</p>
              
              <ol>
                <li><p>
                  You may withdraw your consent for the collection, use and/or disclosure of your personal data in our possession or under our control by submitting your request at the following email address: 
                  <a href="mailto:dpo@hoihup.com">dpo@hoihup.com</a>.
                </p></li>
                <li><p>
                  We will process your request [within a reasonable time] from such a request for withdrawal of consent being made, and will thereafter not collect, use and/or disclose your personal data in the manner stated in your request.
                </p></li>
                <li><p>
                  However, your withdrawal of consent could result in certain legal consequences arising from such withdrawal. In this regard, depending on the extent of your withdrawal of consent for us to process your personal data, it may mean that the contract you have with us will have to be terminated.
                </p></li>
              </ol>
            </li>
          <br />

            <li>
              <p class="doc-title-1">ADMINISTRATION AND MANAGEMENT OF PERSONAL DATA</p>
              
              <ol>
                <li><p>
                  We will take reasonable efforts to ensure that your personal data is accurate and complete, if your personal data is likely to be used by HHSP to make a decision that affects you, or disclosed to another organisation. However, this means that you must also update us of any changes in your personal data that you had initially provided us with. We will not be responsible for relying on inaccurate or incomplete personal data arising from you not updating us of any changes in your personal data that you had initially provided us with.
                </p></li>
                <li><p>
                  We will also put in place reasonable security arrangements to ensure that your personal data is adequately protected and secured. Appropriate security arrangements will be taken to prevent any unauthorised access, collection, use, disclosure, copying, modification, leakage, loss, damage and/or alteration of your personal data. However, we cannot assume responsibility for any unauthorised use of your personal data by third-parties which are wholly attributable to factors beyond our control.
                </p></li>
                <li><p>
                  We will also put in place measures such that your personal data in our possession or under our control is destroyed and/or anonymised as soon as it is reasonable to assume that (i) the purpose for which that personal data was collected is no longer being served by the retention of such personal data; and (ii) retention is no longer necessary for any other legal or business purposes.
                </p></li>
                <li><p>
                  Where your personal data is to be transferred out of Singapore, we will comply with the PDPA in doing so. In this regard, this includes us obtaining your consent unless an exception under the PDPA or law applies, and taking appropriate steps to ascertain that the foreign recipient organisation of the personal data is bound by legally enforceable obligations to provide to the transferred personal data a standard of protection that is at least comparable to the protection under the Act. This may include us entering into an appropriate contract with the foreign recipient organisation dealing with the personal data transfer or permitting the personal data transfer without such a contract if the PDPA or law permits us to.
                </p></li>
              </ol>
            </li>
          <br />

            <li>
              <p class="doc-title-1">COMPLAINT PROCESS</p>
              
              <ol>
                <li><p>
                  If you have any complaint or grievance regarding how we are handling your personal data or about how we are complying with the PDPA, we welcome you to contact us with your complaint or grievance.
                </p></li>
                <li><p>
                  Please contact us with your complaint or grievance at the following email address: <a href="mailto:dpo@hoihup.com">dpo@hoihup.com</a>.
                </p></li>
                <li><p>
                  Where it is an email or a letter through which you are submitting a complaint, your indication at the subject header that it is a PDPA complaint would assist us in attending to your complaint speedily by passing it on to the relevant staff in our organisation to handle. For example, you could insert the subject header as “PDPA Complaint”.
                </p></li>
                <li><p>
                  We will certainly strive to deal with any complaint or grievance that you may have speedily and fairly.
                </p></li>
              </ol>
            </li>
          <br />

            <li>
              <p class="doc-title-1">UPDATES ON DATA PROTECTION POLICY</p>
              <ol>
                <li><p>
                  As part of our efforts to ensure that we properly manage, protect and process your personal data, we will be reviewing our policies, procedures and processes from time to time.
                </p></li>
                <li><p>
                  We reserve the right to amend the terms of this Data Protection Policy at our absolute discretion. Any amended Data Protection Policy will be posted on our website.
                </p></li>
                <li><p>
                  You are encouraged to visit the above website from time to time to ensure that you are well informed of our latest policies in relation to personal data protection.
                </p></li>
              </ol>
            </li>
          </ol>
          <br />
          <p>Last updated on 30 April 2025</p>
        </div>
      </div>
    </div>


    <div v-if="isPopVisible" class="pageUp" @click="scrollTo0()">
      <img class="img-contain" src="@/assets/btn/up.png" alt="">
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      docPopType: false,
      docIndex: 0,
      scrollY: 0, // 当前滚动位置
      currentYear: new Date().getFullYear()
    };
  },

  computed: {
    isPopVisible(){return this.scrollY > 500;},
  },
  beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听
    },
  mounted() {
    window.addEventListener('scroll', this.handleScroll); // 监听滚动事件
  },
  methods: {
    handleScroll() {
            this.scrollY = window.scrollY; // 更新滚动位置
        },
    scrollTo0() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    DocType(index) {
      this.docIndex = index;
      this.docPopType = true;
    },
    downFile(){
      window.open('https://mixgovr.com/WEB/Novo-Place-EC/file/Novo Place eBrochure_Spread View (Hires).pdf')
    },
    OpenUrl(url){
      window.open(url)
    },
  },
};
</script>


<style lang="less">


.flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-row{display: flex;flex-direction: row;}

.content-center{justify-content: center;}
.content-start{justify-content: flex-start;}
.items-center{align-items: center;}
.items-end{align-items: flex-end;}




.Footer {
  width: 90%;
  height: 110px;
  padding: 20px 5%;
  background-color: rgb(241, 238, 230);
  color: #575252;
  font-size: 10px;
  border-top: 4px solid #666b50;
  ::-webkit-scrollbar {
    width: 4px !important;
    height: 5px;
    background-color: #f1eee6;
    border-radius: 6px;
  }
  .pageUp{
    position: fixed;
    right: 10px;
    bottom: 10%;
    width: 50px;
  }
  .down-div-phone{
    display: none;
    font-weight: 400;
  }
  .Pop-win {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .Pop-Bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000000ba;
  }
  .disc-content {
    height: calc(100% - 145px);
    overflow: auto;
    padding: 0 40px;
  }
  .Pop-Disc-Data {
    width: 90%;
    height: 80%;
    /* border-radius:5px; */
    position: relative;
    background-color: white;
    color: black;
    padding: 30px;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    text-align: start;
  }
  .pop-logo {
    height: 90px;
    margin: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .Pop-Disc-Data p {
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
    color: #6d6d6d;
    /* margin: 22px 0; */
  }
  .Pop-x {
    width: 25px;
    /* position: absolute;
      right: 20px;
      top: 20px; */
    /* font-size: 18px; */
    /* font-weight: 400; */
    cursor: pointer;
  }

  .doc-title {
    text-align: start;
    color: #666b50 !important;
    font-weight: 400;
    font-size: 22px !important;
  }
  .doc-title-1 {
    text-align: start;
    /* color: #5d5d5d; */
    color: #666b50;
    font-weight: 400;
    font-size: 16px !important;
  }
  ol {
    list-style-type: none; /* 去掉默认的数字 */
    padding-left: 0; /* 去掉内边距 */
    counter-reset: section; /* 初始化计数器 */
  }

  li {
    counter-increment: section; /* 增加计数器 */
  }

  li::before {
    content: counter(section) ""; /* 自定义格式为 1.1, 1.2 */
    font-weight: bold; /* 自定义数字字体粗细 */
    float: left;
    color: #6d6d6d;
    font-size: 16px;
    line-height: 24px;
    /* margin-right: 10px; */
  }

  /* 嵌套的 ol */
  li ol {
    list-style-type: none; /* 去掉嵌套列表的默认样式 */
    padding-left: 0px; /* 留出内边距 */
    counter-reset: sub-section; /* 初始化嵌套计数器 */
    /* padding-inline-start: 0px; */
  }

  li ol li {
    padding-left: 0px;
    counter-increment: sub-section; /* 增加嵌套计数器 */
  }

  li ol li::before {
    content: counter(section) "." counter(sub-section); /* 自定义格式为 1.1.1, 1.1.2 */
    font-weight: normal; /* 嵌套列表项的字体粗细 */
    padding-left: 0px;
    font-size: 14px;
    line-height: 24px;
    /* margin-right: 10px; */
  }

  /* 嵌套的 ol */
  li ol li ol {
    list-style-type: none;
    // padding-left: 15px !important; /* 留出内边距 */
    counter-reset: section2;
  }
  li ol li ol li {
    padding-left: 0px;
    counter-increment: section2; /* 增加计数器 */
  }
  li ol li ol li::before {
    content: "(" counter(section2, lower-alpha) ") ";
    font-size: 14px;
    line-height: 24px;
  }
  /* li ol li ol li::marker{
            content: "(" counter(section2,lower-alpha) ") "; 
            font-size: 14px;
            line-height: 24px;
        } */
  li ol li ol li p {
    margin-left: 1.5rem !important;
  }
  li p {
    margin-left: 30px;
  }
}
.Footer-left {
  width: 50%;
  height: 100%;
  // font-size: 14px;
}
.Footer-left-img1 {
  height: 60%;
  margin-bottom: 30px;
  object-fit: contain;
}
.Footer-left-div {
  // margin-left: 45px;
  font-weight: 400;
}
.Footer-left-div:nth-child(1){
      align-items: start;
    }
.Footer-left-div:nth-child(2){
     margin-left: 40px;
    }
.c-logo-title {
  // margin-top: -20px;
  margin-bottom: 5px;
  margin-left: 10px !important;
}
.left-div-logo {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.l-logo img {
  cursor: pointer;
  width: 40px;
  margin: 5px;
}
.c-logo img {
  width: 120px;
  margin: 10px;
}
.Footer-left-div p {
  margin-left: 10px;
  letter-spacing: 2px;
  font-weight: 400;
  white-space: nowrap;
}

.Footer-right {
  // margin-right: 45px;
  // font-size: 14px;
  font-weight: 400;
  display: flex;
  width: 50%;
  .down-div{
    cursor: pointer;
    display: flex;align-items: center;font-weight: 400;
  }
}

@media (max-width: 900px) {
  .Footer{
    display: none !important;
  }
  .Footer .disc-content{
    padding: 0 20px !important;
  }
  .underline{
    text-underline-offset: 2px;
  }
  .Footer{
    height: auto;
    flex-direction: column !important;
    padding-bottom: 20px;
    // font-family: auto !important;
      .down-div-phone{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: row;
        letter-spacing: 2px;
        width: 95%;
        img{
          width: 15px !important;
        }
    }
    li::before{
      font-size: 12px !important;
      line-height: 15px;
    }
    .Pop-Disc-Data{
      padding: 0;
      .doc-title{
        font-size: 14px !important;
      }
      .doc-title-1{
        font-size: 12px !important;
      }
      p{
        font-size: 12px !important;
        line-height: 15px;
      }
    }
    .pop-logo{
      height: 75px;
      margin-top: 75px;
      margin-bottom: 10px;
      width: auto;
    }
    .Pop-x{
      width: 20px;
      // padding-right: 15px;
      // padding-top: 15px;
    }
    .disc-content{
      text-align: justify;
    }
    .Footer-left,.Footer-right{
      width: 100%;
      // align-items: center;
      // justify-content: space-between;
      // flex-direction: column;
      margin: 0;
    }
    .Footer-left{
      justify-content: space-between;
    }
    .Footer-left-div:nth-child(2){
      align-items: end;
    }


    .Footer-left-div{
      margin: 0;
      font-size: 10px !important;
      align-items: start;
      // flex-direction: column;
      flex-direction: column-reverse;
      .c-logo-title{
        margin: 0;
        margin-top: 10px;
      }
      p{
        margin-left: 0;
      }
    }
    .Footer-right{
      font-size: 9px !important;
      white-space: nowrap;
      justify-content:center;
      margin-top: 20px;
      .down-div{
        display: none;
      }
    }
    .l-logo img{
  width: 35px !important;
}
.c-logo img{
  width: 85px !important;
}
  }



}


</style>






